import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import { DateTime } from 'luxon';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FORMAT_DATE } from '../../const';
import { ComponentsDispatch, RootState } from '../../store';
import { setterGantScroll } from '../../store/slices/gantScrollSlice';
import { setterGant } from '../../store/slices/gantSlice';
import { HeaderType, ModeTimeLineType } from '../../types';

const ButtonPagination = () => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const modeTimeLine = useSelector<RootState, ModeTimeLineType>((state) => state.gant.modeTimeLine);
    const headerType = useSelector<RootState, HeaderType>((state) => state.gant.headerType);
    const currentOffsetDate = useSelector<RootState, string>((state) => state.gant.currentOffsetDate);
    const startDateExtend = useSelector<RootState, string>((state) => state.gant.startDateExtend);
    const endDateExtend = useSelector<RootState, string>((state) => state.gant.endDateExtend);
    const widthColumn = useSelector<RootState, number>((state) => state.gant.widthColumn);

    const setCurrentScroll = (newCurrentOffsetDay: DateTime) => {
        const shiftDaysFromStart = newCurrentOffsetDay.diff(DateTime.fromISO(startDateExtend), 'days').days;

        const isOutLeftBorder = newCurrentOffsetDay.toSeconds() < DateTime.fromISO(startDateExtend).toSeconds();
        const isOutRightBorder =
            newCurrentOffsetDay.toSeconds() >= DateTime.fromISO(endDateExtend).toSeconds() - 4 * 24 * 60 * 60;

        const newDateExtend = DateTime.fromISO(startDateExtend).plus({
            days: isOutRightBorder ? shiftDaysFromStart + 3 : shiftDaysFromStart,
        });

        if (isOutLeftBorder) {
            dispatch(
                setterGantScroll({
                    currentScrollX: 0,
                }),
            );
            dispatch(
                setterGant({
                    startDateExtend: newDateExtend.toFormat(FORMAT_DATE),
                }),
            );
        } else if (isOutRightBorder) {
            dispatch(
                setterGant({
                    endDateExtend: newDateExtend.plus({ [headerType]: 1 }).toFormat(FORMAT_DATE),
                }),
            );
            dispatch(
                setterGantScroll({
                    currentScrollX: Math.round(shiftDaysFromStart * widthColumn),
                }),
            );
        } else {
            dispatch(
                setterGantScroll({
                    currentScrollX: Math.round(shiftDaysFromStart * widthColumn),
                }),
            );
        }
    };

    const handleLeft = () => {
        const newCurrentOffsetDay = DateTime.fromISO(currentOffsetDate).minus({
            [headerType]: 1,
        });
        setCurrentScroll(newCurrentOffsetDay);
    };

    const handleRight = () => {
        const newCurrentOffsetDay = DateTime.fromISO(currentOffsetDate).plus({
            [headerType]: 1,
        });
        setCurrentScroll(newCurrentOffsetDay);
    };

    return (
        <>
            {modeTimeLine === 'pagination' && (
                <Space>
                    <Button onClick={handleLeft}>
                        <LeftOutlined />
                    </Button>
                    <Button onClick={handleRight}>
                        <RightOutlined />
                    </Button>
                </Space>
            )}
        </>
    );
};

export default ButtonPagination;
